module.exports = __webpack_public_path__ + "static/media/6511.89707fb6.jpg";